import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Box, IconButton, Typography, styled, Divider, Avatar, MenuItem, MenuList, useMediaQuery } from '@mui/material';
import { DRAWER_WIDTH, COMPACT_DRAWER_WIDTH } from '../sidebar/constants';
import {
    BackButton,
    Hamburger,
    Notification,
    Search,
} from '../../assets/header-icons';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Popover from '@mui/material/Popover';
import routeNames from '../../routes/routeNames';
import { logout } from '../../redux/thunks/userThunks';

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open, compact }) => ({
    backgroundColor:"#FFFFFF",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: 0,
        width: `calc(100% - ${compact === 'true' ? DRAWER_WIDTH : COMPACT_DRAWER_WIDTH}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

export default function Header(props) {
    const {
        openDrawer,
        drawerOpen,
        closeDrawer,
        headerTitle = 'Dashboard',
    } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [popOpen, setPopOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    
    const { userDetails } = useSelector((state) => state.user);
    const { first_name ="", last_name="", email="", image_url="" } = userDetails;

    const handleClick = (event) => {
        event.preventDefault();
        setPopOpen(true);
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setPopOpen(false);
    };

    const handleLogout = async() => {
        handleClose();
        dispatch(logout()).then(()=> {
             /* navigate('/login'); */ 
            window.location.href = "/login";
        }).catch(error =>  console.error("Error in logout ", error));
        
    };

    return (
        <AppBar
            elevation={0}
            position="fixed"
            open={true}
            compact={drawerOpen.toString()}
            className='no-box-shadow padding-0'
        >
            <Toolbar className="bg-white height-72px">
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={!drawerOpen ? openDrawer : closeDrawer}
                    edge="start"
                    sx={{
                        display:{
                            xs: 'block',
                            lg: 'none',
                            md:'block'
                        }
                    }}
                >
                    <Box>
                        {!drawerOpen &&  <Hamburger />}
                    </Box>
                </IconButton>
                <Typography
                    noWrap
                    className="display-xs-medium gray-900 ml-17px"
                >
                    {headerTitle}
                </Typography>
                <Box className="flex-row-align-items-center gap-29 ml-auto">
                    <Box className="flex-row gap-12">
                        <Avatar
                            src={image_url}
                            className="user-profile"
                            alt={`${first_name} ${last_name}`}
                        />
                        <Box className="flex-column" sx={{display:{
                            xs:"none",
                            lg:'block',
                            md:'block'
                        }}}>
                            <Typography className="text-xs-medium gray-700 text-align-left">
                                {`${first_name} ${last_name}`}
                            </Typography>
                            <Typography className="text-xs-regular gray-500">
                                {email}
                            </Typography>
                        </Box>
                        <Box className="flex-column-center ml-auto icon">
                            <KeyboardArrowDownIcon 
                                className="gray-500 wh-25px"
                                onClick={handleClick}
                            />   
                            <Popover
                                open={popOpen}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                disableScrollLock={true}
                            >
                                <MenuList>
                                    <MenuItem
                                        onClick={() => {
                                            handleClose();
                                            navigate(routeNames.SETTINGS);
                                        }}
                                        disableRipple>
                                        View Profile
                                    </MenuItem>
                                    <MenuItem
                                        onClick={handleLogout}>
                                        Log Out
                                    </MenuItem>
                                </MenuList>
                            </Popover>
                        </Box>
                        
                    </Box>
                </Box>
            </Toolbar>
            <Divider className="bg-gray-200" />
        </AppBar>
    );
}
